export const getToken = () => {
	return localStorage.getItem('token') || null;
}

export const setToken = (token) => {
	localStorage.setItem('token', token)
}

export const clearToken = () => {
	localStorage.removeItem('token')
}

export const clearAll = () => {
	localStorage.clear();
}
